import ServiceClient from './service-client';
class OperacaoService {
  static async listAtivasAsync(representadaId, filter) {
    try {
      var result = await ServiceClient.Get(
        `/operacao/list-ativas?representadaId=${representadaId}`,
        filter
      );

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async listAtivasVinculadasAsync(representadaId, filter) {
    try {
      var result = await ServiceClient.Get(
        `/operacao/list-ativas-vinculadas?representadaId=${representadaId}`,
        filter
      );

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }
}

export default OperacaoService;
